export default function (key) {
  let keyText = key.replace(/([A-Z])/g, ' $1').trim().replace(/_/g, ' ')
  return keyText.charAt(0).toUpperCase() + keyText.slice(1)
}
